import React from 'react';
import { render } from '@testing-library/react-native';
import { DisabledCardTooltip } from '..';

jest.mock('rn-tooltip', () => 'DisablesCardTooltip');

describe('DisabledCardTooltip component', () => {
  it('render <DisabledCardTooltip />', () => {
    const component = render(
      <DisabledCardTooltip title="Tooltip title" message="Tooltip message" />
    );
    expect(component).toBeDefined();
    expect(component.toJSON()).toMatchSnapshot();
  });
});
